import ol_ext_inherits from 'ol-ext/util/ext'
import ol_control_Toggle from 'ol-ext/control/Toggle'


var collectLayers = function (layers) {
    var layers_ = [];
    layers.forEach(function (value) {
        layers_.push(value);
        if (value.get("layers")) {
            layers_ = layers_.concat(collectLayers(value.getLayers()));
        }
    });

    return layers_;


}

/**
 * @classdesc
 * A button control which, when pressed, shows a legend in an popup box. 
 * To style this control use the css selector `.ol-legend`.
 *
 * @constructor
 * @extends {ol.control.Control}
 * @param {olx.control.Legend=} opt_options Options.
 * @api
 */
function LegendControl(opt_options) {
    var options = opt_options || {};
    options.title = options.title || "Legende";
    options.html = (options.html || "<span class='icon'></span>");
    options.className = options.className || "ol-legende";

    this.selector_ = options.selector ? options.selector : "#legend";

    var closeElem = document.querySelector(this.selector_ + " .close");
    if (closeElem) {
        closeElem.addEventListener("click", function () {
            this.setActive(false);
        }.bind(this));
    }
    ol_control_Toggle.call(this, options);
};
ol_ext_inherits(LegendControl, ol_control_Toggle);


LegendControl.prototype.setActive = function (active) {
    if (this.getMap() === null) {
        return;
    }
    var elem = document.querySelector(this.selector_);
    if (!elem) {
        return;
    }
    if (active) {
        elem.style.display = "block";
    } else {
        elem.style.display = "none";
    }
    ol_control_Toggle.prototype.setActive.call(this, active);
};

LegendControl.prototype.setMap = function (map) {
    ol_control_Toggle.prototype.setMap.call(this, map);
    /*
    if (!this.viewChangeBind) {
        this.viewChangeBind = this.viewChange.bind(this);
    }

    if (this.map_) {
        this.map_.un('moveend', this.viewChangeBind, this);
        this.map_.on('moveend', this.viewChangeBind, this);
    }



    this.viewChange();
    */
};


LegendControl.prototype.viewChange = function (event) {
    if (this.map_) {
        var res = this.map_.getView().getResolution();
        var layers = collectLayers(this.map_.getLayers());
        layers.forEach(function (layer) {
            var elem = document.querySelector(this.selector_ + " ." + layer.get("name"));
            if (elem) {
                if (!layer.getVisible() || layer.getMaxResolution() <= res || layer.getMinResolution() >= res) {
                    elem.style.display = "none";
                } else {
                    elem.style.display = "block";
                }
            }
        }.bind(this));
    }



};

export default LegendControl;
